import "@/styles/auth.css";

/* Command Deck auth shell: brand showcase panel (desktop) + form panel.
   On mobile the brand panel drops away and a centered Shootzu wordmark
   appears above the form (via .auth-mobile-logo). */

export const AUTH_GRADIENT =
  "linear-gradient(157deg,#5D2E84 0%,#3A1D57 30%,#1A1038 62%,#0A0E1A 100%)";

/* Shared inline style tokens (exact design values) */
export const authStyles = {
  label: { fontSize: "11.5px", color: "rgba(255,255,255,.5)", marginBottom: 6, display: "block" },
  input: {
    width: "100%",
    padding: "13px 14px",
    border: "1px solid rgba(255,255,255,.14)",
    borderRadius: 12,
    background: "rgba(255,255,255,.04)",
    color: "#fff",
    fontFamily: "'Work Sans', sans-serif",
    fontSize: 14,
    outline: "none",
    transition: "border-color .15s",
  },
  primaryBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    background: "#28C0D0",
    border: "none",
    color: "#0C1120",
    fontFamily: "'Work Sans', sans-serif",
    fontWeight: 700,
    fontSize: "14.5px",
    cursor: "pointer",
    boxShadow: "0 12px 28px -10px rgba(40,192,208,.6)",
  },
  heading: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 800,
    fontSize: 28,
    color: "#fff",
    letterSpacing: "-.6px",
  },
  sub: { fontSize: 14, color: "rgba(255,255,255,.6)", marginTop: 6 },
};

const AuthLayout = ({ children }) => {
  return (
    <div
      className="auth-root"
      style={{
        minHeight: "100vh",
        display: "flex",
        fontFamily: "'Work Sans', system-ui, sans-serif",
        background: AUTH_GRADIENT,
        backgroundAttachment: "fixed",
      }}
    >
      {/* BRAND PANEL — desktop only */}
      <div
        className="auth-brand"
        style={{
          flex: "1 1 46%",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "48px 52px",
          borderRight: "1px solid rgba(255,255,255,.08)",
        }}
      >
        {/* drifting aqua bloom */}
        <div
          className="auth-bloom"
          style={{
            position: "absolute",
            top: -120,
            left: -80,
            width: 520,
            height: 460,
            borderRadius: "50%",
            background: "radial-gradient(closest-side,rgba(40,192,208,.22),transparent 70%)",
            animation: "szbloom 26s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />
        {/* rotating symbol watermark */}
        <img
          src="/assets/shootzu-icon.png"
          alt=""
          className="auth-watermark"
          style={{
            position: "absolute",
            right: -90,
            bottom: -70,
            width: 420,
            height: 420,
            opacity: 0.06,
            animation: "szspin 90s linear infinite",
            pointerEvents: "none",
          }}
        />

        <img
          src="/assets/shootzu-logo-white.png"
          alt="Shootzu"
          style={{ height: 38, width: "auto", alignSelf: "flex-start", display: "block", position: "relative", zIndex: 1 }}
        />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 800,
              fontSize: 42,
              lineHeight: 1.08,
              letterSpacing: "-1.4px",
              color: "#fff",
            }}
          >
            The next shoot is<br />
            looking for{" "}
            <span
              style={{
                background: "linear-gradient(110deg,#67C6B4,#28C0D0 45%,#C98AD4)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              you.
            </span>
          </div>
          <div style={{ fontSize: 15, color: "rgba(255,255,255,.7)", marginTop: 16, maxWidth: 420, lineHeight: 1.6 }}>
            Australia&rsquo;s professional network for photo &amp; video crew. Find work, build your crew, get paid on time.
          </div>
          <div style={{ display: "flex", gap: 30, marginTop: 30 }}>
            {[
              ["2,000+", "Vetted pros"],
              ["Every state", "Australia-wide"],
              ["Photo + Video", "crew & roles"],
            ].map(([big, small]) => (
              <div key={big}>
                <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: 24, color: "#fff" }}>{big}</div>
                <div style={{ fontSize: "12.5px", color: "rgba(255,255,255,.55)" }}>{small}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ position: "relative", zIndex: 1, fontSize: 12, color: "rgba(255,255,255,.4)" }}>
          Built by crew, for crew · Turbo Productions, Melbourne
        </div>
      </div>

      {/* FORM PANEL */}
      <div
        style={{
          flex: "1 1 54%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 24px",
          minHeight: "100vh",
          overflowY: "auto",
        }}
      >
        <div style={{ width: "100%", maxWidth: 404 }}>
          {/* mobile-only centered wordmark */}
          <div className="auth-mobile-logo" style={{ justifyContent: "center", marginBottom: 30 }}>
            <img src="/assets/shootzu-logo-white.png" alt="Shootzu" style={{ height: 52, width: "auto", display: "block" }} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
